module.exports = __webpack_public_path__ + "img/bag-handle.79bed14a.svg";